import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

/**
 * "Date of Return" input. Required, but the empty check lives in the caller's
 * submit handler — react-datepicker renders a text input, so the `required`
 * attribute below doesn't block form submission on its own.
 *
 * `error` carries the backend's validation message for this field (e.g. the
 * date being earlier than the device's date of claim), which only comes back
 * on submit — so it's shown next to the input rather than in a toast alone.
 */
const DateOfReturnField = ({ value, onChange, error }) => (
  <div className="form-field warranty-date-of-return">
    <label htmlFor="dateOfReturn">Date of Claim*</label>
    <DatePicker
      id="dateOfReturn"
      className={error ? "form-control is-invalid" : "form-control"}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={error ? "dateOfReturn-error" : undefined}
      selected={value}
      dateFormat="dd/MM/yyyy"
      placeholderText="DD/MM/YYYY"
      maxDate={moment().toDate()}
      onChange={onChange}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      yearDropdownItemNumber={10}
      popperProps={{ strategy: "fixed" }}
      required
    />
    {error && (
      <div id="dateOfReturn-error" className="invalid-feedback d-block">
        {error}
      </div>
    )}
  </div>
);

export default DateOfReturnField;
